<template>
  <div>
    <section class="feature-area section-padding2 toubugaodu"
      style=" height: 400px; background: url('../static/assets/images/bannerc.jpg') no-repeat;background-size: 100% auto;">
      <div class="container">
        <div class="row toubugaoduzt" style="height: 400px; line-height: 400px;color: #ffffff;font-size: 45px;">
          <div class="col-lg-12">
            <div class="section-top text-center">
              <p style=" font-style: initial; ">关于我们</p>
            </div>
          </div>
        </div>

      </div>
      <div class="about_tab">
        <router-link class="about_tab_jj" to="/about" @click.native="reloadPage">企业简介</router-link>
        <router-link class="about_tab_wh" to="/wenhua" @click.native="reloadPage"
          style="background: #0473db;color: #ffffff;">企业文化</router-link>
        <router-link class="about_tab_jg" to="/jiagou" @click.native="reloadPage">企业架构</router-link>
        <router-link class="about_tab_zr" to="/zeren" @click.native="reloadPage">认证体系</router-link>
        <router-link class="about_tab_sm" to="/shengming" @click.native="reloadPage">版权声明</router-link>
      </div>
    </section>
    <section class="feature-area section-padding2 wenhua_section1">
      <div class="container julidingbu" style="padding-top: 150px;">
        <div class="row" style="height: 600px;">
          <div class="wenhua_news wow fadeInLeft animated" style="width:100%">
            <!-- <p v-html="aboutinfo.content"></p> -->
            <div style="width: 100%;position: absolute; top: 0px;">
              <div class="wenhuaz912" style="width:50%;float: left;height:250px;">
                <div class="whz912"
                  style="float:left;background: #c1d2f0; width: 90%;margin-left: 5%; border-radius: 10px; height: 250px; ">
                  <div class="wenhua912"
                    style="width:30%;float: left;margin-left:5%;  height: 250px;  line-height: 250px;">
                    <img src="/static/assets/images/wenhua020.png" alt="">
                  </div>
                  <div class="wenhua2912"
                    style="width:50%;float: left; text-align:left; padding-top:80px ;    line-height: 36px;">
                    <p style="font-size:16px;font-weight:600">我们的核心价值观</p>
                    <p style="font-size:16px;">协作 进步 责任</p>
                  </div>
                </div>
              </div>
              <div class="wenhuaz912" style="width:50%;float: left;height:250px;">
                <div class="whz912"
                  style="float:left;background: #c1d2f0; width: 90%;margin-left: 5%; border-radius: 10px; height: 250px;">
                  <div class="wenhua912"
                    style="width:30%;float: left;margin-left:5%;    height: 250px;  line-height: 250px;">
                    <img src="/static/assets/images/wenhua010.png" alt="">
                  </div>
                  <div class="wenhua2912"
                    style="width:50%;float: left; text-align:left; padding-top:46px ;    line-height: 36px;">
                    <p style="font-size:16px;font-weight:600">我们的责任</p>
                    <p style="font-size:16px;">我们精诚团结，追求科技创新，不断进取。对员工负责、对客户负责、对股东负责、对社会及环境负责始终是拿度肩负之重任</p>
                  </div>
                </div>
              </div>
              <div class="wenhuaz912" style="width:50%;float: left;height:250px;margin-top:20px">
                <div class="whz912"
                  style="float:left;background: #c1d2f0; width: 90%;margin-left: 5%; border-radius: 10px; height: 250px;">
                  <div class="wenhua912"
                    style="width:30%;float: left;margin-left:5%;   height: 250px;  line-height: 250px;">
                    <img src="/static/assets/images/wenhua030.png" alt="">
                  </div>
                  <div class="wenhua2912"
                    style="width:50%;float: left; text-align:left; padding-top:46px ;    line-height: 36px;">
                    <p style="font-size:16px;font-weight:600">我们的行事准则</p>
                    <p style="font-size:16px;">技术上追求“度”，做事上立本于“度”，“拿度” 始终是烟台拿度智能科技有限公司价值所向，恒基之本。</p>
                  </div>
                </div>
              </div>
              <div style="width:50%;float: left;height:250px;margin-top:20px">
                <div class="wenhuabeijing912"
                  style="float:left; width: 90%;  background:url('../static/assets/images/1723017944930851.png') no-repeat;background-size: 100% auto; margin-left: 5%; border-radius: 10px; height: 250px;">

                </div>
              </div>
            </div>
          </div>
          <!-- <div class="wenhua_news wow fadeInRight animated">
				<img src="/static/assets/images/wenhua02.png"/>
			</div>
			<div class="wenhua_news wow fadeInLeft animated">
				<img src="/static/assets/images/wenhua03.png"/>
			</div>
			<div class="wenhua_news wow fadeInRight animated">
				<img src="/static/assets/images/wenhua04.png"/>
			</div> -->
        </div>
      </div>
    </section>
    <!-- Feature Area End -->


    <!-- Team Area Starts -->
    <section class="team-area section-padding2">
      <div style="width: 100%;">

        <div class="advantage_num">
          <ul>
            <li class="wow fadeInLeft animated" style="visibility: visible; animation-name: fadeInLeft;">
              <div class="img_box"><img src="/static/assets/images/advantage01.jpg" alt=""></div>
              <div class="text_box">
                <span><em class="counter">6</em><i>大</i></span>
                <p>主要业务板块，<br>
                  磁致伸缩位移传感器、激光传感器</p>
              </div>
            </li>
            <li class="wow fadeInLeft animated" style="visibility: visible; animation-name: fadeInLeft;">
              <div class="img_box"><img src="/static/assets/images/advantage02.jpg" alt=""></div>
              <div class="text_box">
                <span><em class="counter">10</em><i>年</i></span>
                <p>十年以上的行业经验，<br>
                  强大的传感器研发、设计和测试工程师团队</p>
              </div>
            </li>
            <li class="wow fadeInLeft animated" style="visibility: visible; animation-name: fadeInLeft;">
              <div class="img_box"><img src="/static/assets/images/advantage03.jpg" alt=""></div>
              <div class="text_box">
                <span><em class="counter">60</em><i>种</i></span>
                <p>位移传感器产品，<br>
                  技术上追求“度”，做事上立本于“度”</p>
              </div>
            </li>

          </ul>
        </div>

      </div>
    </section>
    <!-- Team Area End -->

  </div>
</template>

<script>
import axios from 'axios';
export default {
  data() {
    return {
      aboutinfo: [],
      newurl: 'https://naduapi.jurenkeji.com.cn',
    };
  },
  mounted() {
    //公司信息
    axios.postForm('https://naduapi.jurenkeji.com.cn/api.php/about/22', {
      appid: 'jurenkeji2024',
      timestamp: '1722845854',
      signature: '0eb76b812e96966c380b90c6e7416a26'
    })
      .then(response => {
        console.log(response.data.data);
        this.aboutinfo = response.data.data;

      })
      .catch(error => {
        console.error('当前网络环境异常!', error);
      });
  },
  methods: {
    reloadPage() {
      // console.log('3333')
      // 如果不是因为导航重复而出现错误，则重新加载页面
      window.location.reload()
    },
    // 截取新闻标题字符串至指定长度
    truncatecontent(dateStr, length = 20) {
      return dateStr.substring(0, length);
    },


  }
};
</script>



// WEBPACK FOOTER //
// Wenhua.vue?10cfbb9a